import { setPagination } from '../State/pagination';
import { setSorting } from '../State/sorting';
import fetchSuppliers from '../Services/fetchSuppliers';

export default (pagination, filters, sorter) => async (dispatch) => {

  if (pagination) {
    dispatch(setPagination({
      current: pagination.current,
      pageSize: pagination.pageSize
    }));
  }

  if (sorter && sorter.columnKey) {
    dispatch(setSorting({
      columnKey: sorter.columnKey,
      order: sorter.order
    }));
  }

  dispatch(fetchSuppliers());
}
